import { render, staticRenderFns } from "./AgreementBasics.vue?vue&type=template&id=6376228b"
import script from "./AgreementBasics.vue?vue&type=script&lang=js"
export * from "./AgreementBasics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports